import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export default function AuthenticatedRoute({ component: Component, ...rest }) {
  const isAuthenticated = localStorage.getItem('data') ? JSON.parse(localStorage.getItem('data')) : false;
  return (
    <Route
      {...rest}
      render={props => (
        isAuthenticated.accessToken ? (
          <Component {...props} />
        ) : (
            <Redirect to={{
              pathname: '/',
              state: { from: props.location },
            }}
            />
          )
      )}
    />);
}



// WEBPACK FOOTER //
// ./src/Modules/HOC/AuthenticatedRoute/component.jsx